import script from "./centerBar.vue?vue&type=script&setup=true&lang=js"
export * from "./centerBar.vue?vue&type=script&setup=true&lang=js"

export default script